(() => {
  'use strict';
  const NEEDS = {sommeil:'nuit-paisible',digestion:'digestion',detente:'relax',energie:'energy',detox:'detox',immunite:'immunite'};
  const CORE_HANDLES = ['nuit-paisible','digestion','relax','energy'];
  const HANDLES = Object.values(NEEDS);
  const URL_PARAMETER = 'dizane_selection';

  function validSelection(selection, uniqueChoices = false) {
    if (![1,2,3,4].includes(selection.length) || selection.some(v => !v?.available || !HANDLES.includes(v.handle))) return false;
    if (uniqueChoices && new Set(selection.map(v => String(v.productId))).size !== selection.length) return false;
    const quantities = new Map();
    selection.forEach(variant => { const key = String(variant.id); quantities.set(key,(quantities.get(key) || 0) + 1); });
    return selection.every(variant => {
      const quantity = quantities.get(String(variant.id));
      const minimum = Number(variant.min) || 1;
      const step = Number(variant.step) || 1;
      return quantity >= minimum && (quantity - minimum) % step === 0 && (variant.max == null || quantity <= Number(variant.max));
    });
  }

  function quote(selection, currency) {
    if (!validSelection(selection)) return null;
    if (selection.length === 1) return Number.isFinite(Number(selection[0].price)) ? Number(selection[0].price) : null;
    if (currency !== 'EUR' || !selection.every(v => Number(v.price) === 1990)) return null;
    // Six-formula native offers and all quantity partitions verified in Shopify.
    return ({2:3582,3:4896,4:5972})[selection.length] ?? null;
  }

  function discoverySelection(chosen, variants, size = 4) {
    const available = handle => variants.some(v => v.handle === handle && v.available);
    return [...new Set([...chosen,...CORE_HANDLES])].filter(available).slice(0,size);
  }

  function recommend(answers, variants) {
    const chosen = [...new Set(answers.needs || [])].map(key => NEEDS[key]).filter(Boolean);
    const available = handle => variants.find(v => v.handle === handle && v.available);
    const primary = chosen[0];
    if (!primary || !available(primary)) return {handles:[],reason:'Cette formule est momentanément indisponible. Modifiez votre priorité.'};
    const wanted = chosen.filter(available);
    const audience = ['solo','pair','share'].includes(answers.audience) ? answers.audience : 'solo';
    if (answers.intent === 'discovery') {
      const handles = discoverySelection(wanted,variants);
      return {handles,reason:handles.every(handle => wanted.includes(handle)) ? 'Vos envies réunies, une formule pour chaque moment choisi.' : 'Vos choix, avec d’autres goûts et moments à découvrir.'};
    }
    const sharedSize = audience === 'share' ? 3 : audience === 'pair' ? 2 : 1;
    if (answers.intent === 'focused') {
      return {handles:Array(sharedSize).fill(primary),reason:sharedSize === 1 ? 'La formule de votre première envie, pour commencer.' : audience === 'pair' ? 'Votre formule ciblée, un flacon pour chacun.' : 'Votre formule ciblée, en trois flacons à partager.'};
    }
    if (audience !== 'solo') {
      const size = wanted.length === 1 ? sharedSize : 4;
      const handles = Array.from({length:size},(_,index) => wanted[index % wanted.length]);
      return {handles,reason:wanted.length === 1 ? audience === 'pair' ? 'Votre formule ciblée, un flacon pour chacun.' : 'Votre formule ciblée, en trois flacons à partager.' : 'Vos formules réunies en quatre flacons, à alterner et à partager.'};
    }
    const handles = wanted.slice(0,4);
    return {handles,reason:handles.length === 1 ? 'La formule de votre première envie, pour commencer.' : 'Une formule pour chacun de vos moments choisis.'};
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = {recommend,quote,validSelection,discoverySelection};
  if (typeof document === 'undefined' || window.dizaneChoiceQuizReady) return;
  window.dizaneChoiceQuizReady = true;

  const getConfig = composer => {
    try { return JSON.parse(composer.querySelector('[data-bundle-config]').textContent); } catch { return null; }
  };
  const nativeComposition = (composer, ids) => {
    const config = getConfig(composer);
    const size = ids.length;
    const selectors = [...composer.querySelectorAll('[data-bundle-choice]')];
    const radio = composer.querySelector('[data-bundle-size][value="' + size + '"]');
    if (!config || ![2,3,4].includes(size) || !radio || selectors.length < size || !composer.dataset.bundleReady) return {ok:false,reason:'not-ready'};
    if ([...composer.querySelectorAll('[data-bundle-size]')].some(node => node.disabled)) return {ok:false,reason:'busy'};
    const available = ids.every(id => config.variants.some(v => String(v.id) === String(id) && v.available && HANDLES.includes(v.handle)));
    const selectable = ids.every((id,index) => [...selectors[index].options].some(option => option.value === String(id) && !option.disabled));
    if (!available || !selectable) {
      selectors.forEach((select,index) => { select.value = ids[index] ? String(ids[index]) : ''; });
      radio.checked = true;
      selectors[0].dispatchEvent(new Event('change',{bubbles:true}));
      return {ok:false,reason:'unavailable'};
    }
    selectors.forEach((select,index) => { select.value = ids[index] ? String(ids[index]) : ''; });
    radio.checked = true;
    radio.dispatchEvent(new Event('change',{bubbles:true}));
    return {ok:composer.dataset.planValid === 'true',reason:composer.dataset.planValid === 'true' ? null : 'invalid-selection'};
  };

  const destination = (path, ids) => {
    const url = new URL(path,window.location.origin);
    const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id',preview);
    if (ids) url.searchParams.set(URL_PARAMETER,ids.join(','));
    return url.href;
  };

  let pendingSelection;
  try {
    const raw = new URL(window.location.href).searchParams.get(URL_PARAMETER);
    pendingSelection = raw && /^\d+(,\d+){1,3}$/.test(raw) ? raw.split(',') : null;
  } catch { pendingSelection = null; }
  let applyingURL = false;
  function applyURLSelection() {
    if (!pendingSelection || applyingURL) return;
    const composer = document.querySelector('[data-dizane-bundles][data-bundle-ready]');
    if (!composer) return;
    applyingURL = true;
    const result = nativeComposition(composer,pendingSelection);
    if (result.reason === 'busy' || result.reason === 'not-ready') { applyingURL = false; return; }
    const url = new URL(window.location.href);
    url.searchParams.delete(URL_PARAMETER);
    window.history.replaceState(window.history.state,'',url);
    pendingSelection = null;
    const notice = document.createElement('p');
    notice.className = 'dq-selection-notice';
    notice.setAttribute('role','status');
    notice.textContent = result.ok ? 'Votre sélection est prête. Vérifiez vos flacons avant de les ajouter au panier.' : result.reason === 'unavailable' ? 'Une formule de votre sélection n’est plus disponible. Choisissez vos flacons ci-dessous.' : 'Vérifiez les quantités de votre sélection avant de poursuivre.';
    composer.prepend(notice);
    applyingURL = false;
  }
  document.addEventListener('dizane:bundle:change',applyURLSelection);

  function initialize(scope = document) {
    scope.querySelectorAll('[data-dizane-choice-quiz]').forEach(section => {
      if (section.dataset.quizReady) return;
      const dialog = section.querySelector('[data-quiz-dialog]');
      const opener = section.querySelector('[data-quiz-open]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      section.dataset.quizReady = 'true';
      opener.setAttribute('aria-haspopup','dialog');
      const form = section.querySelector('[data-quiz-form]');
      const title = section.querySelector('[data-quiz-title]');
      const progress = section.querySelector('[data-quiz-progress]');
      const next = section.querySelector('[data-quiz-next]');
      const back = section.querySelector('[data-quiz-back]');
      const apply = section.querySelector('[data-quiz-apply]');
      const status = section.querySelector('[data-quiz-status]');
      const resultPanel = section.querySelector('[data-quiz-result]');
      const titles = ['Quelles sont vos envies du moment ?','Comment aimeriez-vous découvrir Dizane ?','Vous en profiterez…','Votre sélection.'];
      let step = 0, answers = {needs:[],intent:null,audience:null}, selection = [], reason = '', config = null, previousFocus = null, previousOverflow = '';
      const money = cents => new Intl.NumberFormat(config?.locale || 'fr-FR',{style:'currency',currency:config?.currency || 'EUR'}).format(cents / 100);
      const variants = () => config?.variants?.filter(v => HANDLES.includes(v.handle)) || [];
      const currentVariants = () => selection.map(id => variants().find(v => String(v.id) === String(id)));
      const shortName = variant => variant?.title?.replace(/^Dizane\s+/i,'') || 'À choisir';
      const validStep = () => step === 0 ? answers.needs.length > 0 : step === 1 ? Boolean(answers.intent) : Boolean(answers.audience);
      const focusTitle = () => { dialog.scrollTop = 0; title.focus({preventScroll:true}); };

      function renderResult() {
        const selected = currentVariants();
        const valid = validSelection(selected,Boolean(config?.uniqueChoices));
        const price = quote(selected,config?.currency);
        const subtotal = selected.reduce((sum,v) => sum + Number(v?.price || 0),0);
        const composition = section.querySelector('[data-quiz-composition]');
        composition.replaceChildren();
        const quantities = new Map();
        selected.forEach(v => { const key = shortName(v); quantities.set(key,(quantities.get(key) || 0) + 1); });
        quantities.forEach((quantity,name) => { const line = document.createElement('li'); line.textContent = quantity + ' × ' + name; composition.append(line); });
        title.textContent = ({1:'Votre Dizane.',2:'Votre duo.',3:'Votre trio.',4:'Votre coffret.'})[selected.length] || 'Votre sélection.';
        section.querySelector('[data-quiz-edit] summary').textContent = selected.length > 1 ? 'Commencer avec moins de flacons' : 'Modifier ma sélection';
        section.querySelector('[data-quiz-reason]').textContent = reason;
        section.querySelector('[data-quiz-price]').textContent = valid ? money(price ?? subtotal) : 'À vérifier';
        section.querySelector('[data-quiz-value]').textContent = selected.length * 25 + ' verres à 10 ml' + (selected.length > 1 && price != null ? ' · −' + ({2:10,3:18,4:25}[selected.length]) + ' %' : '');
        const verifiedOffer = valid && price != null;
        section.querySelector('[data-quiz-gift]').hidden = selected.length !== 4 || !verifiedOffer || !config?.gift?.available;
        const extras = answers.needs.map(key => NEEDS[key]).filter(handle => !selected.some(v => v?.handle === handle)).map(handle => variants().find(v => v.handle === handle && v.available)).filter(Boolean);
        const extraLinks = section.querySelector('[data-quiz-extra-links]');
        extraLinks.replaceChildren();
        extras.forEach(variant => { const link = document.createElement('a'); link.href = destination('/products/' + variant.handle + '?dizane_offer=1'); link.textContent = shortName(variant) + ' · ' + money(Number(variant.price)) + ' à l’unité →'; extraLinks.append(link); });
        section.querySelector('[data-quiz-extras]').hidden = extras.length === 0;
        section.querySelector('[data-quiz-shipping]').textContent = selected.length >= 3 && verifiedOffer ? 'Point relais offert en France métropolitaine. Autres livraisons : frais au paiement.' : 'Frais de livraison calculés au paiement.';
        if (price == null) section.querySelector('[data-quiz-shipping]').textContent += ' Prix et offres éventuelles confirmés au panier.';
        form.querySelectorAll('[name="format"]').forEach(input => { input.checked = Number(input.value) === selection.length; });
        const selects = section.querySelector('[data-quiz-selects]');
        selects.replaceChildren();
        selection.forEach((id,index) => {
          const label = document.createElement('label');
          label.textContent = 'Flacon ' + (index + 1);
          const select = document.createElement('select');
          select.dataset.quizFormula = String(index);
          select.setAttribute('aria-label','Flacon ' + (index + 1));
          variants().forEach(variant => { const option = document.createElement('option'); option.value = String(variant.id); option.textContent = shortName(variant) + (variant.available ? '' : ' · indisponible'); option.disabled = !variant.available; select.append(option); });
          select.value = String(id);
          label.append(select); selects.append(label);
        });
        apply.disabled = !valid;
        status.textContent = valid ? '' : 'Cette quantité n’est pas disponible. Modifiez votre sélection.';
        apply.textContent = selection.length === 2 ? 'Vérifier mon duo' : 'Voir ma sélection';
      }

      function render() {
        title.textContent = titles[step];
        progress.textContent = step < 3 ? 'Question ' + (step + 1) + ' sur 3' : '';
        progress.hidden = step === 3;
        section.querySelectorAll('[data-quiz-step]').forEach(panel => { panel.hidden = Number(panel.dataset.quizStep) !== step; });
        resultPanel.hidden = step !== 3;
        next.hidden = step === 3;
        next.disabled = !validStep();
        next.textContent = step === 2 ? 'Voir ma sélection' : 'Continuer';
        back.hidden = step === 0;
        back.textContent = step === 3 ? 'Mes réponses' : 'Retour';
        apply.hidden = step !== 3;
        status.textContent = '';
        if (step === 3) renderResult();
      }

      function close(restoreFocus = true) {
        dialog.close();
        document.body.style.overflow = previousOverflow;
        if (restoreFocus && previousFocus?.isConnected) previousFocus.focus({preventScroll:true});
      }

      opener.addEventListener('click',event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const composer = document.querySelector('[data-essential-home] [data-dizane-bundles]') || document.querySelector('[data-dizane-bundles]');
        config = composer && getConfig(composer);
        if (!config?.variants?.length) return;
        event.preventDefault();
        previousFocus = document.activeElement;
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        form.querySelectorAll('[name="need"]').forEach(input => {
          input.disabled = !variants().some(v => v.handle === NEEDS[input.value] && v.available);
          if (input.disabled && input.checked) { input.checked = false; answers.needs = answers.needs.filter(key => key !== input.value); }
        });
        if (!answers.needs.length) step = 0;
        render();
        dialog.showModal();
        focusTitle();
      });
      section.querySelector('[data-quiz-close]').addEventListener('click',() => close());
      dialog.addEventListener('cancel',event => { event.preventDefault(); close(); });
      dialog.addEventListener('click',event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
      });
      dialog.addEventListener('keydown',event => {
        if (event.key !== 'Tab') return;
        const focusable = [...dialog.querySelectorAll('a[href],button:not(:disabled),input:not(:disabled),select:not(:disabled),summary,[tabindex="0"]')].filter(node => {
          const closedDetails = node.closest('details:not([open])');
          return node.getClientRects().length && !node.closest('[hidden]') && (!closedDetails || node === closedDetails.querySelector(':scope > summary'));
        });
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (!first) { event.preventDefault(); return; }
        if (event.shiftKey && (document.activeElement === first || document.activeElement === title)) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
      form.addEventListener('change',event => {
        const input = event.target;
        if (input.name === 'need') answers.needs = input.checked ? [...answers.needs.filter(key => key !== input.value),input.value] : answers.needs.filter(key => key !== input.value);
        else if (input.name === 'intent') answers.intent = input.value;
        else if (input.name === 'audience') answers.audience = input.value;
        else if (input.name === 'format') {
          const size = Number(input.value);
          const chosenHandles = currentVariants().filter(Boolean).map(v => v.handle);
          const priority = chosenHandles[0] || NEEDS[answers.needs[0]];
          const available = variants().filter(v => v.available);
          const discovery = discoverySelection([...chosenHandles,...answers.needs.map(key => NEEDS[key])],available);
          const handles = size === 4 && answers.intent === 'discovery' && discovery.length === 4 ? discovery : Array.from({length:size},(_,index) => chosenHandles[index] || priority);
          selection = handles.map(handle => available.find(v => v.handle === handle)?.id).filter(Boolean);
          reason = 'Votre sélection, ajustée selon vos envies.';
          renderResult();
          form.querySelector('[name="format"][value="' + selection.length + '"]')?.focus();
        } else if (input.hasAttribute('data-quiz-formula')) {
          const index = Number(input.dataset.quizFormula);
          selection[index] = input.value;
          reason = 'Votre sélection, ajustée selon vos envies.';
          renderResult();
          form.querySelector('[data-quiz-formula="' + index + '"]')?.focus();
        }
        next.disabled = !validStep();
      });
      form.addEventListener('submit',event => {
        event.preventDefault();
        if (step >= 3 || !validStep()) return;
        if (step === 2) {
          const result = recommend(answers,variants());
          selection = result.handles.map(handle => variants().find(v => v.handle === handle && v.available)?.id).filter(Boolean);
          reason = result.reason;
          section.querySelector('[data-quiz-edit]').open = false;
        }
        step += 1;
        render(); focusTitle();
      });
      back.addEventListener('click',() => { step = Math.max(0,step - 1); render(); focusTitle(); });

      apply.addEventListener('click',() => {
        const selected = currentVariants();
        if (!validSelection(selected,Boolean(config?.uniqueChoices))) { status.textContent = 'Vérifiez les formules et les quantités de votre sélection.'; return; }
        const home = document.querySelector('[data-essential-home][data-essential-ready]');
        const composer = home?.querySelector('[data-dizane-bundles][data-bundle-ready]');
        const key = Object.keys(NEEDS).find(need => NEEDS[need] === selected[0].handle);
        if (selection.length === 2 || !home || !composer || selected.some(v => !CORE_HANDLES.includes(v.handle))) {
          const path = selection.length === 1 ? '/products/' + selected[0].handle + '?dizane_offer=1' : '/collections/all?view=coffrets';
          window.location.assign(destination(path,selection.length === 1 ? null : selection));
          return;
        }
        const needButton = home.querySelector('[data-home-need="' + key + '"]');
        const offerButton = home.querySelector('[data-home-offer="' + selection.length + '"]');
        if (!needButton || !offerButton || needButton.disabled || [...composer.querySelectorAll('[data-bundle-size]')].some(node => node.disabled)) { status.textContent = 'Un ajout est en cours. Réessayez une fois votre panier confirmé.'; return; }
        needButton.click();
        if (offerButton.disabled) { status.textContent = 'Cette formule est momentanément indisponible.'; return; }
        offerButton.click();
        const result = selection.length === 1 ? {ok:!home.querySelector('[data-home-solo]').hidden} : nativeComposition(composer,selection);
        if (!result.ok) { status.textContent = 'La sélection doit être vérifiée. Modifiez vos formules ou réessayez.'; return; }
        close(false);
        home.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
        const target = selection.length === 1 ? home.querySelector('[data-home-solo] button[type="submit"]') : composer.querySelector('[data-bundle-submit]');
        target?.focus({preventScroll:true});
      });
    });
    applyURLSelection();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => initialize());
  else initialize();
  document.addEventListener('shopify:section:load',event => initialize(event.target));
})();
